import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import ContactPopup from './ContactPopup';
import { emailValidationProps } from '../utils/formValidation';
import { BaseUrl } from '../helper/BaseUrl';
import { toast } from 'react-toastify';

export default function Footer() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";
  const sourceUrl = typeof window !== "undefined" ? sessionStorage.getItem("source_url") || "" : "";

  const [formData, setFormData] = useState({
    email: "",
    name: "",
    source_url: sourceUrl,
    current_url: currentUrl,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "name") {
      const onlyLetters = /^[A-Za-z\s]*$/;
      if (!onlyLetters.test(value)) {
        return;
      }
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Full Name is required";
    } else if (!/^[A-Za-z\s]+$/.test(formData.name.trim())) {
      newErrors.name = "Name can contain only letters and spaces";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(formData.email.trim())) {
        newErrors.email = "Please enter a valid email";
      }
    }


    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    try {
      setLoading(true);
      const response = await fetch(`${BaseUrl}/api/newsletter/store`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();

      if (result.error === false) {
        navigate("/thank-you");
      } else {
        toast.error(result.message || "Failed to subscribe.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong while submitting the form.");
    } finally {
      setLoading(false);
    }
  };



  return (
    <div>
      <footer className="footer-section">
        <div className="container">
          <div className="row">

            <div className="col-lg-3 col-sm-6">
              <div className="bootom-footer">
                <div className="footer-menu">
                  <a href="mailto:info@catalyze.co.in">
                    <i className="fa-solid fa-envelope"></i> info@catalyze.co.in
                  </a>
                  <a href="tel:+91 9056260016">
                    <i className="fa-solid fa-phone"></i> +91 9056260016
                  </a>
                </div>

                <div className="footer-social">
                  <ul className="menu-social">
                    {/* <li>
                      <a href="https://www.facebook.com/" target="_blank" rel="noreferrer">
                        <i className="fa-brands fa-facebook-f social-icon"></i>
                      </a>
                    </li> */}
                    <li className="social-instagram">
                      <a href="https://www.instagram.com/catalyze.official/?hl=en" target="_blank" rel="noreferrer">
                        <i className="fa-brands fa-instagram social-icon"></i>
                      </a>
                    </li>
                    {/* <li>
                      <a href="https://x.com/" target="_blank" rel="noreferrer">
                        <i className="fa-brands fa-x-twitter social-icon"></i>
                      </a>
                    </li> */}
                    <li className="social-linkedin">
                      <a href="https://www.linkedin.com/company/catalyze-official/" target="_blank" rel="noreferrer">
                        <i className="fa-brands fa-linkedin-in social-icon"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6">
              <div className="bootom-footer">
                <div className="footer-menu">
                  <ul className="list-inline">
                    <li><Link to="/about-us">About Catalyze</Link></li>
                    <li><Link to="/founder">Founder</Link></li>
                    <li><Link to="/blogs">Blogs</Link></li>
                    <li><Link to="/contact">Contact Us</Link></li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-sm-12">
              <form onSubmit={handleSubmit}>
                <div className="contact-form row">

                  <div className="col-lg-12">
                    <div className="become-title">Become A Change Enthusiast</div>
                    <p>Join our community of leaders making a difference</p>
                  </div>

                  <div className="col-lg-5">
                    <div className="form-group">
                      <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control" placeholder="Full Name *" />
                      {errors.name && (<span className="validation-error"> {errors.name} </span>)}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <input className="form-control" name="email" value={formData.email} onChange={handleChange} placeholder="Email *" />
                      {errors.email && (<span className="validation-error"> {errors.email} </span>)}
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="form-group">
                      <button type="submit" className="footer-submit-link" disabled={loading}>
                        {loading ? "Submitting..." : "Let’s Do This "}  
                           <i className="fa-solid fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>

                </div>
              </form>
            </div>

            <div className="col-lg-12">
              <div className="copyright-footer">
                <p>&copy; 2026 All rights reserved by Catalyze</p>
                <div className="footer-menu">
                  <ul className="list-inline">
                    <li><a href="">Privacy Policy</a></li>
                    <li><a href="">Terms of Service</a></li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </footer>
      <ContactPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  )
}
